import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import styled from "styled-components";


// import n_img from "../partners/tools/science_cover.jpg";
import n_img from "../partners/tools/soyuz.jpg";
import ScienceSelectTool from "../partners/tools/ScinceSelectTool";
import { TopAb2 } from "./science-labs-page";

const ScienceSelectPage = () => {

    const [bigUrl, setBigUrl] = useState(undefined);
    const { t, i18n } = useTranslation();
    let isRu = i18n.language == "ru";


    return (
        <OuterWrapper className={"about_page"}>
            <TopAb2 style={{
                backgroundImage: `url(${n_img})`,
            }}>
                {
                    isRu ? "Научно-популярный туризм" : "Science tourism"
                }
            </TopAb2>

            <Wrapper>
                {/*<TopImg src={n_img} />*/}

                <TopPlaceholder>
                    {/*<SupTopPlaceholder>*/}
                    {/*    <BackLink href={"/"}></BackLink>*/}
                    {/*</SupTopPlaceholder>*/}
                    {/*<Heading>*/}
                    {/*    Наука*/}
                    {/*</Heading>*/}

                    <TopTextPlaceholder>
                        {isRu ?
                            'Погрузитесь в мир академических открытий с разделом "Наука в университетах", где представлены объекты научной инфраструктуры университетов.'
                            : 'Dive into the world of academic discoveries with the "Science in Universities" section, showcasing the scientific infrastructure of universities.'
                        }

                        <br />
                        <br />

                        {isRu ?
                            <>
                                Раздел "Наука в движении" дает уникальную возможность ознакомиться с объектами
                                научно-популярного туризма, практическими исследованиями и окунуться в мир путешествий
                            </>
                            :
                            <>
                                The "Science in Motion" section offers a unique opportunity to explore sites of science tourism, engage in practical research, and immerse yourself in the world of travel.
                            </>
                        }


                    </TopTextPlaceholder>

                </TopPlaceholder>

                <ScienceSelectTool

                />


            </Wrapper>

        </OuterWrapper>
    );
};

const TopTextPlaceholder = styled.div`
  width: 1360px;
  box-sizing: border-box;
  //padding: 15px;
  font-family: "Noto Sans", sans-serif;
  line-height: 32px;
  font-size: 24px;
  text-align: center;

  margin: 0 auto;
  //text-align: justify;

  text-align: center;
  
  margin-bottom: 50px;
  margin-top: 50px;


  @media (max-width: 1360px) {
    width: 100%;
  }
`;


const OuterWrapper = styled.div`
  width: 100%;
  background: white;
  padding-top: 30px;
  box-sizing: border-box;
  padding-bottom: 40px;
`;

const Wrapper = styled.div`
  text-align: left;

  font-family: "Noto Sans", sans-serif;

  box-sizing: border-box;
  width: 1400px;
  margin: 0 auto;
  padding: 15px;
  @media (max-width: 1400px) {
    width: 100%;
  }
`;

const Heading = styled.div`
  font-family: "Noto Sans", sans-serif;
  text-align: center;
  font-style: normal;
  font-weight: 700;
  font-size: 56px;
  line-height: 72px;
  margin-bottom: 40px;
  @media (max-width: 820px) {
    font-size: 24px;
    line-height: 32px;
    padding-left: 5px;
  }
`;

const SupTopPlaceholder = styled.div`
  margin-bottom: 20px;
`;

const TopPlaceholder = styled.div``;

export default ScienceSelectPage;
